import { memo, useId } from "react";
import PropTypes from "prop-types";
import ToolTip from "../../../../../parts/tooltip";

/**
 * Section title row: label (uppercase) + optional “?” tooltip + optional horizontal rule.
 * `showRule={false}` for INTENSITY ZONES (tooltip only, no horizontal rule).
 */
function InsightsSectionHeading({
  title,
  titleId,
  infoAriaLabel,
  infoTooltipBody,
  showRule = true,
}) {
  const tooltipId = `program-insights-section-${useId().replaceAll(":", "")}`;
  const tooltipBody = infoTooltipBody ?? infoAriaLabel ?? "";

  return (
    <div className="ProgramInsights-sectionHeadingBar">
      <h4 id={titleId} className="ProgramInsights-sectionTitle">
        {title}
      </h4>
      {infoAriaLabel ? (
        <ToolTip
          id={tooltipId}
          className="ProgramInsights-metricRow-info ProgramInsights-sectionHeadingInfo"
          body={tooltipBody}
        >
          <span
            className="ProgramInsights-metricRow-infoHint"
            role="img"
            aria-label={infoAriaLabel}
          >
            ?
          </span>
        </ToolTip>
      ) : null}
      {showRule ? (
        <span
          className="ProgramInsights-sectionHeadingRule"
          aria-hidden="true"
        />
      ) : null}
    </div>
  );
}

InsightsSectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  /** Optional DOM id for aria-labelledby on the parent section (unique per column via useId). */
  titleId: PropTypes.string,
  /** Shown as aria-label on the “?” and as tooltip body unless `infoTooltipBody` is set. */
  infoAriaLabel: PropTypes.string,
  /** Optional tooltip copy when it should differ from the aria label. */
  infoTooltipBody: PropTypes.string,
  /** When false (INTENSITY ZONES), no horizontal rule. */
  showRule: PropTypes.bool,
};

export default memo(InsightsSectionHeading);
